// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./private/fonts/league-spartan/_webfonts/stylesheet.css
// module id = 347
// module chunks = 0